import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";

import "primeicons/primeicons.css";

import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";
import { statusConfig } from "../../utils";
import MenuPoint from "../../shared/compoments/MenuPoint.jsx";
// import { MdEdit, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoMdEye } from "react-icons/io";
import { styleIcone } from "../../shared";
import { IoPersonOutline } from "react-icons/io5";
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";

// const options = [
//   {
//     name: "Voir plus",
//     // path: "/requetes/",
//     icone: <IoMdEye style={styleIcone} />,
//     isIdData: true,
//     addMethodClick: true,
//         methode: (idData) => {
//           console.log(idData)
//           navigate("/requetes/"+idData)
//         },
//   },
//   // {
//   //   name: "Modifier",
//   //   path: "/requetes/",
//   //   icone: <MdEdit style={styleIcone} />,
//   //   isIdData: true,
//   // },
//   // {
//   //   name: "Supprimer la requete",
//   //   path: "/requetes/",
//   //   icone: <MdDelete style={styleIcone} />,
//   //   isIdData: true,
//   // },
// ];

function ListRequete() {
  const navigate = useNavigate();
  const [requete, setRequete] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const options = [
    {
      name: "Voir plus",
      // path: "/requetes/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        changeStatut(idData);
      },
    },
    // {
    //   name: "Modifier",
    //   path: "/requetes/",
    //   icone: <MdEdit style={styleIcone} />,
    //   isIdData: true,
    // },
    // {
    //   name: "Supprimer la requete",
    //   path: "/requetes/",
    //   icone: <MdDelete style={styleIcone} />,
    //   isIdData: true,
    // },
  ];
  const ITEMSFILTER = ["nom", "prenom", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const changeStatut = async (id) => {
    try {
      const response = await instance.put("requetes/" + id, {
        statut: "en cours",
      });
      console.log("response", response);
      navigate("/requetes/" + id);
    } catch (error) {
      console.log(error);
      alert(error.response.data.message);
    }
  };

  useEffect(() => {
    const getListRequetes = async () => {
      try {
        const response = await instance.get("requetes");
        console.log("getListRequetes", response);
        setRequete(response.data.data.sort((a, b) => b.flag - a.flag));
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListRequetes();
  }, []);

  return (
    <AllCompomentShared
      libelleHeaderComp={"Liste des requêtes"}
      titleStatisticHeaderComp={"Nombre de requêtes"}
      nbreTotalStatistiqueComp={requete.length}
      SearchTableIsBtn={false}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"} />} //import { IoPersonOutline } from "react-icons/io5";
      isLoading={isLoading}>
      <RequetesDatatable
        items={requete}
        isLoading={isLoading}
        itemsForFilter={ITEMSFILTER}
        filters={filters}
        options={options}
      />
    </AllCompomentShared>
  );
}
export function RequetesDatatable({ items, itemsForFilter, filters, options }) {
  // const dispatch = useDispatch();
  const dt = useRef(null);
  // const navigate = useNavigate();

  // const footer = `${items ? items.length : 0} requetes.`;

  // const saveFacture = (id)=>{
  //   navigate('/requete/creer-facture/'+parseInt(id))
  // }

  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  // const handleProfile = (rowData) => {
  //   if (rowData.proprietaire_id) {
  //     return <p>{"Propriétaire"}</p>;
  //   }
  //   if (rowData.client_id) {
  //     return <p>{"Client"}</p>;
  //   }
  // };
  const handleStatut = (rowData) => {
    return (
      <span
        className="badge text-dark p-3 rounded-5"
        style={{
          background: statusConfig[rowData.statut],
        }}>
        {rowData.statut}
      </span>
    );
  };

  const getNameClient = (rowData) => {
    return (
      <p style={{ textTransform: "uppercase" }}>
        {rowData.nom_client} {rowData.prenom_client}
      </p>
    );
  };
  const getDate = (rowData) => {
    return <p>{new Date(rowData.created_at).toLocaleDateString("fr")}</p>;
  };

  return (
    <div>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={itemsForFilter}>
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Date d'enregistrement"
              body={getDate}></Column>
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Nom & prénoms"
              body={getNameClient}></Column>
            <Column
              field="type_reque"
              style={{ textAlign: "center", position: "relative" }}
              header="Catégorie de demande"></Column>
            <Column
              field="statut"
              style={{ textAlign: "center" }}
              header="Statut de la requete"
              body={handleStatut}></Column>

            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListRequete;
